import { ScrollAnimContext } from "@/contexts/ScrollAnimContext";
import { cubicBezier, motion, MotionValue, useTransform } from "motion/react";
import { useContext } from "react";

export default function PopIn({
  children,
  scrollProgress,
  scrollOffset = 0,
}: {
  children: React.ReactNode;
  scrollProgress?: MotionValue<number>;
  scrollOffset?: number;
}) {
  // Animate
  const scrollYProgress = scrollProgress ? scrollProgress : useContext(ScrollAnimContext);
  const inputRange = [0.2, 0.25, 0.275, 0.33];
  const offsetInputRange = inputRange.map((e) => e + scrollOffset);
  const scale = useTransform(scrollYProgress, offsetInputRange, [0, 2.7, 0.9, 1], { ease: cubicBezier(0.34, 1.56, 0.64, 1) });

  return <motion.div style={{ scale: scale }}>{children}</motion.div>;
}
